import { Component, ViewChild } from '@angular/core';
import { ControlContainer, FormsModule, NgForm, NgModelGroup } from '@angular/forms';

import { IDemographicsGroup, ISelectOption } from 'app/models/filter-form.models';
import { AgeGroup, Gender, Race } from 'app/models/filter.models';
import { FilterService } from 'app/services/filter.service';
import { makeControlDirty } from 'app/utils/form.utils';
import { FilterItemComponent } from '../filter-item/filter-item.component';
import { MatFormField } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { NgFor } from '@angular/common';
import { MatOption } from '@angular/material/autocomplete';

@Component({
  selector: 'app-demographics-tab',
  templateUrl: './demographics-tab.component.html',
  styleUrls: ['./demographics-tab.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  imports: [FormsModule, FilterItemComponent, MatFormField, MatSelect, NgFor, MatOption],
})
export class DemographicsTabComponent {
  @ViewChild('demographics') ngModelGroup!: NgModelGroup;

  demographicsGroup: IDemographicsGroup = {
    races: undefined,
    gender: undefined,
    ageGroup: undefined,
  };

  raceOptions: ISelectOption<Race>[] = [
    { value: Race.HISPANIC_LATINO, viewValue: 'Hispanic / Latino' },
    { value: Race.WHITE, viewValue: 'White' },
    { value: Race.BLACK, viewValue: 'Black' },
    {
      value: Race.ASIAN_PACIFIC_ISLANDER,
      viewValue: 'Asian / Pacific Islander',
    },
    {
      value: Race.ALASKA_AMERICAN,
      viewValue: 'Alaska Native / American Indian',
    },
    {
      value: Race.MIDDLE_EASTERN_NORTH_AFRICAN,
      viewValue: 'Middle Eastern / North African',
    },
  ];

  genderOptions: ISelectOption<Gender>[] = [
    { value: Gender.MALE, viewValue: 'Male' },
    { value: Gender.FEMALE, viewValue: 'Female' },
  ];

  ageGroupOptions: ISelectOption<AgeGroup>[] = [
    { value: AgeGroup.ADULT, viewValue: 'Adult' },
    { value: AgeGroup.MINOR, viewValue: 'Minor' },
  ];

  constructor(private filterService: FilterService) {
    const { appliedFilters: filters } = this.filterService;

    if (!filters.demographicFilter) return;

    this.demographicsGroup = {
      races: filters.demographicFilter.races,
      gender: filters.demographicFilter.gender,
      ageGroup: filters.demographicFilter.ageGroup,
    };
  }

  get racesValue(): string | undefined {
    const selectedRaces = this.demographicsGroup.races?.map(
      (race) => this.raceOptions.find(({ value }) => value === race)?.viewValue,
    );

    return selectedRaces?.length ? selectedRaces.toString() : undefined;
  }

  get genderValue(): string | undefined {
    return this.genderOptions.find(({ value }) => this.demographicsGroup.gender === value)?.viewValue;
  }

  get ageGroupValue(): string | undefined {
    return this.ageGroupOptions.find(({ value }) => this.demographicsGroup.ageGroup === value)?.viewValue;
  }

  clearFilter(filter: 'races' | 'gender' | 'ageGroup'): () => void {
    return () => {
      makeControlDirty(this.ngModelGroup.control);

      switch (filter) {
        case 'races':
          this.demographicsGroup.races = undefined;
          break;
        case 'gender':
          this.demographicsGroup.gender = undefined;
          break;
        case 'ageGroup':
          this.demographicsGroup.ageGroup = undefined;
          break;
      }
    };
  }
}
